import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";

export default function SebfxButton() {
  const [mode, setMode] = useState("initial");
  const [isManualExpand, setIsManualExpand] = useState(false);
  const timers = useRef({ idle: null, scroll: null, manual: null });

  const clearTimers = () => {
    Object.values(timers.current).forEach((t) => t && clearTimeout(t));
  };

  const startIdleTimer = () => {
    if (isManualExpand) return;
    timers.current.idle = setTimeout(() => {
      setMode("idle");
    }, 7000);
  };

  useEffect(() => {
    startIdleTimer();

    const handleScroll = () => {
      setMode("scrolling");
      setIsManualExpand(false);
      clearTimers();

      timers.current.scroll = setTimeout(() => {
        setMode("initial");
        startIdleTimer();
      }, 1500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimers();
    };
  }, [isManualExpand]);

  const handleClick = () => {
    if (mode === "scrolling") return;
    setIsManualExpand(true);
    setMode("initial");
    
    if (timers.current.manual) clearTimeout(timers.current.manual);
    timers.current.manual = setTimeout(() => {
      setIsManualExpand(false);
    }, 8000);
  };

  const isIdle = mode === "idle";
  const isScrolling = mode === "scrolling";
  const isExpanded = mode === "initial" || isManualExpand;

  return (
    <Box
      onMouseEnter={() => !isScrolling && setMode("initial")}
      onMouseLeave={() => !isScrolling && !isManualExpand && setMode("idle")}
      onClick={handleClick}
      sx={{
        position: "fixed",
        bottom: "70px",
        right: isIdle ? "0px" : "24px",
        zIndex: 9999,
        width: isScrolling ? "50px" : isIdle ? "220px" : "340px",
        height: isScrolling ? "50px" : "auto",
        borderRadius: isScrolling ? "50%" : "16px",
        background: "rgba(16, 97, 145, 0.95)",
        backdropFilter: "blur(10px)",
        boxShadow: isIdle ? "0 4px 20px rgba(0,0,0,0.2)" : "0 8px 32px rgba(0,0,0,0.4)",
        transform: isScrolling 
          ? "scale(0.8)" 
          : isIdle 
          ? "translateX(20px) scale(0.9)" 
          : "translateX(0) scale(1)",
        // SLOW MOTION TRANSITION: Changed 0.4s to 0.8s
        transition: "all 0.8s ease-in-out", 
        overflow: "hidden",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
      }}
    >
      {isScrolling ? (
        <Box sx={{ width: "100%", textAlign: "center", fontSize: "24px" }}>⚡</Box>
      ) : (
        <Box sx={{ p: isIdle ? 1.5 : 2.5, width: "100%", transition: "all 0.8s ease-in-out" }}>
          <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: "4px", background: "linear-gradient(90deg, #c0392b, #27ae60)" }} />

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#27ae60" }} />
            <Box sx={{ fontSize: "10px", color: "#aaa", textTransform: "uppercase" }}>Partner</Box>
          </Box>

          <Box component="h2" sx={{ color: "#fff", fontSize: isIdle ? "16px" : "20px", fontWeight: 600, mb: 0.5 }}>
            Automate Trading
          </Box>

          <Box sx={{ 
            maxHeight: isExpanded ? "200px" : "0px", 
            opacity: isExpanded ? 1 : 0, 
            overflow: "hidden", 
            // SLOW MOTION FADE: Changed 0.5s to 0.8s
            transition: "all 0.8s ease-in-out" 
          }}>
            <Box component="p" sx={{ color: "#ccc", fontSize: "13px", mb: 2, lineHeight: 1.4 }}>
              Get Deriv-powered bots from <strong>SebFX Pro</strong>.
            </Box>
            
            <Box sx={{ display: "flex", gap: "8px" }}>
              <Box component="a" href="https://sebfxpro.site" target="_blank"
                sx={{ bgcolor: "#c0392b", color: "#fff", px: 2, py: 0.8, borderRadius: "20px", fontSize: "12px", textDecoration: "none" }}>
                Start Smart Trading now
              </Box>
            </Box>
          </Box>
          
          {isIdle && (
            <Box sx={{ fontSize: "11px", color: "#27ae60", mt: 0.5 }}>Hover to view details</Box>
          )}
        </Box>
      )}
    </Box>
  );
}